import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UpdatePasswordService} from '../password-reset/service/update-password.service';
import {lastValueFrom} from 'rxjs';
import {UtilsService} from "@shared-services/utils.service";
import {ConsoleContextService} from "@security/console-context.service";
import {ConsoleAuthenticationService} from "@security/console-authentication.service";
import {LoadingService} from "@ui-kit/framework/util/service/loading.service";
import {VerifyOTPRequest} from "@ui-kit/framework/security/model/user.model";

@Component({
  selector: 'app-verify-account',
  templateUrl: './verify-account.component.html',
  styleUrls: ['./verify-account.component.scss']
})
export class VerifyAccountComponent implements OnInit {

  public otpForm;
  public errMessage: string | null = null;
  public loading: boolean = false;
  public len = 0;

  @ViewChild('ngOtpInput') ngOtpInputRef: any;


  constructor(private context: ConsoleContextService,
              private route: ActivatedRoute,
              private fb: FormBuilder,
              private passwordService: UpdatePasswordService,
              private authService: ConsoleAuthenticationService,
              private router: Router,
              public loader: LoadingService,
              private utils: UtilsService
  ) {
    this.otpForm = this.resetForm();

  }


  get userEmail(): string {
    if (this.context.currentUser) {
      return this.context.currentUser.email;
    }
    if (this.route.snapshot.paramMap.get('userEmail')) {
      return this.route.snapshot.paramMap.get('userEmail')!;
    }
    return '';
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: Params) => {
      if (params.hasOwnProperty('sendOtp')) {
        this.onResendOTP(false);
      }
    });
  }

  onResendOTP(showPopUp: boolean = true): void {
    this.loading = true;
    this.errMessage = null;
    this.passwordService.requestOtp(this.context.currentUser!.id!).subscribe(
      () => {
        this.loading = false;
        // show success message
        if (showPopUp) {
          this.utils.openSnackBar('OTP sent successfully');
        }
      },
      (err) => {
        this.loading = false;
        switch (err.status) {
          case 400:
            if ('ValidationException' === err.headers.get('error_code')) {
              this.errMessage = '' + err.headers.get('error_message');
              this.otpForm.get('pin')!.setValue(null);
              this.ngOtpInputRef.setValue(null);
            }
            break;
          default:
            this.utils.openSnackBar('An unexpected error occurred, please try again');
        }
      }
    );
  }

  onVerify() {
    const id = this.context.currentUser!.id!;
    const pin = this.otpForm.value.pin;
    const request: VerifyOTPRequest = {id: id, pin: pin};

    this.loading = true;
    this.errMessage = null;
    lastValueFrom(this.passwordService.verifyNewUserAccount(request))
      .then(
        (res) => {
          this.loading = false;
          this.authService.setToken(res);

          // set user as verified in the context
          this.authService.verifyUser();
          let returnUrl = this.route.snapshot.queryParamMap.get('returnUrl');
          if (returnUrl == null) {
            returnUrl = `${this.context.getCurrentLandlordCode()!}`;
          }

          let queryParams: any = {}
          this.route.snapshot.queryParamMap.keys.filter(key => {
            return key !== 'returnUrl'
          }).forEach(key => {
            queryParams[key] = this.route.snapshot.queryParamMap.get(key);
          });

          this.utils.navigateWithQueryParams(returnUrl, null, queryParams)
            .catch((error: string) => {
              console.log(error)
            });
        },
        (err) => {
          this.loading = false;
          switch (err.status) {
            case 400:
              if ('ValidationException' === err.headers.get('error_code')) {
                this.errMessage = '' + err.headers.get('error_message');
                this.otpForm.get('pin')!.setValue(null);
                this.ngOtpInputRef.setValue(null);
              }
              break;
            default:
              console.log(err);
              this.errMessage = 'An unexpected error occurred, please try again';
          }
        }
      );
  }

  onOtpChange(event: any) {
    this.otpForm.get('pin')!.setValue(event);
    this.len = this.otpForm.value.pin.toString().length;
  }

  private resetForm(): FormGroup {
    return this.fb.group({
      pin: [null, Validators.required],
    });
  }
}
